import { useMemo } from 'react';
import { useIssueTypesAndFields } from '@atlassian/jira-business-entity-project';

type Props = {
	fieldId: string;
	issueTypeId?: string;
};

export const useIsFieldAssociatedWithIssueType = ({ fieldId, issueTypeId }: Props) => {
	const { typesWithFields } = useIssueTypesAndFields({
		issueOperation: 'VIEW',
	});
	const isFieldAssociated = useMemo(() => {
		if (issueTypeId === undefined) {
			return false;
		}
		const issueTypeFields = typesWithFields.find(
			(type) => type.issueType.id === issueTypeId,
		)?.fields;

		return issueTypeFields?.some((issueTypeField) => issueTypeField.id === fieldId) ?? false;
	}, [fieldId, issueTypeId, typesWithFields]);

	return isFieldAssociated;
};
